// extracted by mini-css-extract-plugin
module.exports = {"scrollBarText":"ScrollBar-module--scrollBarText--3uILd","anchorLinks":"ScrollBar-module--anchorLinks--3hn2Q"};